export default __webpack_public_path__ + "static/media/Background.bdde9410.jpg";